import {
  type ColumnConfig,
  ColumnTable,
  type ColumnTableCellProps,
  type ColumnTableRow,
} from '@terminal/components/column-table';

import styles from './SharedTable.module.scss';

export type SharedTableColumn<T> = ColumnConfig<T>;
export type SharedTableDataItem<T> = ColumnTableRow<T>;
export type SharedTableCellProps<T> = ColumnTableCellProps<T>;

export interface SharedTableProps<T> {
  tableData: SharedTableDataItem<T>[];
  tableColumns: SharedTableColumn<T>[];
  onRowClick?: (item: SharedTableDataItem<T>) => void;
}

export const SharedTable = <T extends {}>({
  tableData,
  tableColumns,
  onRowClick,
}: SharedTableProps<T>) => (
  <div className={styles.root}>
    <ColumnTable
      columns={tableColumns}
      data={tableData}
      onRowClick={onRowClick}
    />
  </div>
);
